<div class="d-flex"
  [ngClass]="{'justify-content-between': quantityChangeable, 'justify-content-center': !quantityChangeable}">
  @if (quantityChangeable) {
    <div (click)="onDecreaseQuantity()">
      <i class="icon13 se-icon quantity-icons no-select">electricity_polarity_negative_minus</i>
    </div>
  }
  {{ counter * (apartmentsCount)}}
  @if (quantityChangeable) {
    <div (click)="onIncreaseQuantity()">
      <i class="icon13 se-icon-electricity_polarity_positive_plus quantity-icons no-select"></i>
    </div>
  }
</div>
